import { useEffect, useState } from "react";

const TYPING_SPEED_MS = 72;
const DELETING_SPEED_MS = 34;
const HOLD_DURATION_MS = 1600;
const NEXT_PHRASE_DELAY_MS = 280;

export const HomepageTypewriterHeadline = ({
  phrases = [],
  prefix,
  className = "mt-4 text-4xl font-semibold leading-tight md:text-6xl",
  prefixClassName = "block text-white",
  rotatingClassName = "mt-3 block min-h-[2.55em] text-[#F5D98C] md:min-h-[2.3em]",
  testIdPrefix = "homepage-hero-heading",
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleText, setVisibleText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!phrases.length) return undefined;

    const currentPhrase = phrases[activeIndex] || "";
    let timer;

    if (!isDeleting && visibleText !== currentPhrase) {
      timer = window.setTimeout(() => {
        setVisibleText(currentPhrase.slice(0, visibleText.length + 1));
      }, TYPING_SPEED_MS);
    } else if (!isDeleting && visibleText === currentPhrase) {
      timer = window.setTimeout(() => {
        setIsDeleting(true);
      }, HOLD_DURATION_MS);
    } else if (isDeleting && visibleText.length > 0) {
      timer = window.setTimeout(() => {
        setVisibleText(currentPhrase.slice(0, visibleText.length - 1));
      }, DELETING_SPEED_MS);
    } else {
      timer = window.setTimeout(() => {
        setIsDeleting(false);
        setActiveIndex((current) => (current + 1) % phrases.length);
      }, NEXT_PHRASE_DELAY_MS);
    }

    return () => window.clearTimeout(timer);
  }, [activeIndex, isDeleting, phrases, visibleText]);

  return (
    <h2 className={className} data-testid={testIdPrefix}>
      <span className={prefixClassName} data-testid={`${testIdPrefix}-prefix`}>{prefix}</span>{" "}
      <span className={rotatingClassName} data-testid={`${testIdPrefix}-rotating-wrapper`}>
        <span data-testid={`${testIdPrefix}-rotating-text`}>{visibleText}</span>
        <span aria-hidden="true" className="homepage-typewriter-cursor" data-testid={`${testIdPrefix}-cursor`}>|</span>
      </span>
    </h2>
  );
};